
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/history",
      function () {
        return require("private-next-pages/about/history.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/history"])
      });
    }
  